import React from 'react';
import { useTranslation } from 'react-i18next';

import { Typography } from '@material-ui/core';

import { WIDGET_LINK } from '../../../../config';

import useStyles from './styles';

const Instructions = () => {
  const classes = useStyles();
  const [t] = useTranslation();

  return (
    <div className={classes.instructionsWrapper}>
      <Typography
        style={{ paddingBottom: '15px', fontWeight: 'bold', fontSize: '15px' }}
      >
        {t('Instruction')}
      </Typography>
      <div className={classes.instructionItem}>
        <div className={classes.listNumberMark}>1</div>
        <Typography className={classes.instructionText}>
          {t(
            'If you would like to customize the Horn website widget color scheme, please upload a logo and select the accent color.'
          )}
        </Typography>
      </div>
      <div className={classes.instructionItem}>
        <div className={classes.listNumberMark}>2</div>
        <Typography className={classes.instructionText}>
          {t(
            'To enable the Horn website widget throughout your website, please insert the below script between the Header tags of your website.'
          )}
        </Typography>
      </div>
      <Typography className={classes.linkText}>
        {`<script src="${WIDGET_LINK}"></script>`}
      </Typography>
      <div className={classes.instructionItem}>
        <div className={classes.listNumberMark}>3</div>
        <Typography className={classes.instructionText}>
          {t(
            'Select the Horn website widget type (Product list or Specific unit) above and add a [Book button] by clicking on the "Generate and copy".'
          )}
        </Typography>
      </div>
    </div>
  );
};

export default Instructions;
